
import React from 'react';
import ReactDom from 'react-dom';
import KatlaEditor from './katla';

if( document.getElementById('katla-editor') ){

    ReactDom.render( <KatlaEditor/>, document.getElementById('katla-editor'));

}